import React, {Component } from 'react'

import { styled } from '@mui/styles';

 import { makeStyles } from 'tss-react/mui'; // if you still want to use makeStyles

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles()((theme) => ({
    loading:{
        alignContent: "center;",
        textAlign: "center;",
        paddingTop: "50px;",
        paddingBottom: "150px;",
    },
    CircularProgress:{
        color:"#19A78E"
    }
  }));

const Loader = (props) => {
    const { classes } = useStyles();
    return <Box className={classes.loading}>
        <CircularProgress  className={classes.CircularProgress}/>
        <h4>Loading</h4>

    </Box>
}

export default (Loader);